import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useOnboarding } from "../../../context/AdminSellerRegistrationOB";
import JWTContext from "../../../context/JWTContext";
import { useForm } from "react-hook-form";

const schema = yup
  .object({
    businessType: yup.number().required(),
  })
  .required();

export const BusinessType = Object.freeze({
  PersonalSeller: 0,
  Company: 1,
});

const SellerTypeForm = () => {
  const navigate = useNavigate();

  const { saveStep, data } = useOnboarding();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      businessType: data.businessType ?? null,
    },
  });

  const businessType = watch("businessType");

  const inputClass = (field) =>
    `form-control p-10 ${errors[field] ? "is-invalid" : ""}`;

  const inputradioClass = (field) =>
    `form-radio text-18 ${errors[field] ? "is-invalid" : ""}`;

  const inputcheckClass = (field) =>
    `form-check mb-0 custom-circular-checkbox ${
      errors[field] ? "is-invalid" : ""
    }`;

  const onSubmit = (data) => {
    saveStep({
      businessType: data.businessType,
    });
    if (data.businessType === BusinessType.PersonalSeller) {
      navigate("/admin/document-verification-personal");
    } else {
      navigate("/admin/document-verification-company");
    }
  };

  const onError = (errors) => {
    console.log("FORM ERRORS:", errors);
  };

  const readUserData = () => {
    if (localStorage.getItem("user") == null) {
      navigate("/login");
    }
  };

  useEffect(() => {
    readUserData();
  }, []);

  useEffect(() => {
    if (businessType === undefined || businessType === "") return;

    // save to onboarding context
    saveStep({
      businessType: businessType,
    });

    if (businessType === BusinessType.PersonalSeller) {
      navigate("/admin/document-verification-personal");
    } else if (businessType === BusinessType.Company) {
      navigate("/admin/document-verification-company");
    }
  }, [businessType]);

  return (
    <div className="document-verification text_quicksand">
      <div className="container">
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <div className="form-group mb-40 mt-30">
            <div className="d-flex flex-wrap d-md-nowrap justify-content-center justify-content-md-between mx-auto mt-60 customradiocontainer">
              <div className="mb-20 ">
                <label className="label-stylized-icon flex-center">
                  <input
                    type="radio"
                    {...register("businessType")}
                    value={BusinessType.PersonalSeller}
                    className={inputradioClass("businessType") + " d-none"}
                    onChange={(e) => {
                      setValue("businessType", parseInt(e.target.value));
                    }}
                  />
                  <div className="radio-card">
                    <img
                      src="/assets/images/icon/store-circle.png"
                      className="mx-auto text-center d-block mb-20"
                    ></img>
                    <div className="mx-auto mb-10 text-center">
                      <span className="text-18 fw-bold text-black text-center">
                        Personal Seller
                      </span>
                    </div>
                    <div className="mx-auto mb-20 text-center">
                      <span
                        className="text-14 text-center"
                        style={{ color: " rgba(102, 102, 102, 1)" }}
                      >
                        For Personal Online Shop / Brand Owner
                      </span>
                    </div>
                    <div
                      className="btn btn_mart_secondary mx-auto d-block mx-auto mt-20 select-btn"
                      style={{ width: "170px" }}
                    >
                      SELECT
                    </div>
                  </div>
                </label>
              </div>
              <div className="mb-20">
                <label className="label-stylized-icon flex-center">
                  <input
                    type="radio"
                    {...register("businessType")}
                    value={BusinessType.Company}
                    className={inputradioClass("businessType") + " d-none"}
                    onChange={(e) => {
                      setValue("businessType", parseInt(e.target.value));
                    }}
                  />
                  <div className="radio-card">
                    <img
                      src="/assets/images/icon/building-circle.png"
                      className="mx-auto text-center d-block mb-20"
                    ></img>
                    <div className="mx-auto mb-10 text-center">
                      <span className="text-18 fw-bold text-black text-center">
                        Company
                      </span>
                    </div>
                    <div className="mx-auto mb-20 text-center">
                      <span
                        className="text-14 text-center"
                        style={{ color: " rgba(102, 102, 102, 1)" }}
                      >
                        For Personal Online Shop / Brand Owner
                      </span>
                    </div>
                    <div
                      className="btn btn_mart_secondary mx-auto d-block mx-auto mt-20 select-btn"
                      style={{ width: "170px" }}
                    >
                      SELECT
                    </div>
                  </div>
                </label>
              </div>
            </div>

            {errors.businessType && (
              <small className="text-danger">
                {errors.businessType.message}
              </small>
            )}
          </div>

          <div className="d-flex justify-content-end">
            {/* <button className="btn btn_mart_primary" onClick={() => navigate("/registration-shop-information")} >Next</button> */}
            {/* <button className="btn btn_mart_primary" type="submit" >Next</button> */}
          </div>
        </form>
      </div>
    </div>
  );
};

export default SellerTypeForm;
